<template>
  <div>
    <yetkidialog ref="yetkidialog"></yetkidialog>

    <v-layout row justify-center>
      <v-dialog v-model="dialog" persistent max-width="300px">
        <v-card color="grey lighten-5">
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>{{dialog_baslik}}</v-toolbar-title>

            </v-toolbar>
          </v-flex>
          <v-card-text>
            <v-form ref="formdizayn" v-model="valid" lazy-validation>
              <v-layout row="" wrap>
                <v-text-field :label="$t('Design-Table-Name')" hide-details="" :rules="[v => !!v || $t('Mandatory-Areas')]"
                  :color="color" v-model="ListInput.FaturaTabloAdi">
                </v-text-field>

                <v-text-field :label="$t('Description')" :rules="[v => !!v || $t('Mandatory-Areas')]" hide-details="" :color="color"
                  v-model="ListInput.FaturaAciklama">
                </v-text-field>
                <v-select :items="xsltitems" :rules="[v => !!v || $t('Mandatory-Areas')]" v-model="ListInput.FaturaXsltId"
                  clearable item-text="XsltAciklama" item-value="FaturaId" :label="$t('Select-xslt-File')"></v-select>
                <reportbrosablon :rules="[v => !!v || $t('Mandatory-Areas')]" ref="reportbrosablon"
                  v-model="ListInput.FaturaPdfID" dizayngrupadi="Fatura"
                  objectname="Controllers.ReportBro.Invoice.InvoicePrint"></reportbrosablon>
                <v-layout>
                  <v-radio-group v-model="ListInput.FaturaIcDis" hide-details="" :label="$t('Invoice-Type')">
                    <v-radio :label="$t('Domestic-Line')" value="I"></v-radio>
                    <v-radio :label="$t('International-Line')" value="D"></v-radio>
                    <v-radio :label="$t('Free')" value="S"></v-radio>
                  </v-radio-group>
                  <v-radio-group v-model="ListInput.FaturaTLDoviz" hide-details="" :label="'TL/'+$t('Currency')">
                    <v-radio label="TL" value="T"></v-radio>
                    <v-radio :label="$t('Currency')" value="D"></v-radio>
                  </v-radio-group>
                </v-layout>
              </v-layout>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="vazgec()">{{$t('Cancel')}}</v-btn>
            <div v-show="m === true">

                     <v-tooltip bottom>
                <v-btn :disabled="!sayfayetki.Delete" slot="activator" color="blue darken-1" flat @click="silsor()"> {{ $t('Delete') }}
                </v-btn>
                <span v-if="!sayfayetki.Delete">{{ $t('Limited-Authorization') }}</span>
                <span v-if="sayfayetki.Delete">{{ $t('Delete') }}</span>
              </v-tooltip>

              <v-tooltip bottom>
                <v-btn :disabled="!sayfayetki.Update" slot="activator" color="blue darken-1" flat @click="Kaydet()">
                  {{ $t('Update') }}
                </v-btn>
                <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                <span v-if="sayfayetki.Update">{{ $t('Update') }}</span>
              </v-tooltip>


            </div>

            <div v-show="k === true">
              <v-tooltip bottom>
                <v-btn :disabled="!sayfayetki.Save" slot="activator" v-if="k==true" id="bkaydet" color="blue darken-1"
                  flat @click="Kaydet()"> {{$t("save_button")}}
                </v-btn>
                <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
                <span v-if="sayfayetki.Save">{{$t("save_button")}}</span>
              </v-tooltip>
            </div>



          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout row wrap>
      <v-toolbar dark color="info">
        <v-toolbar-title> {{ $t('Invoice-Design-Identification') }} </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-text-field flat="" solo-inverted="" hide-details v-model="search3" :label="$t('Search')" append-icon="search">
        </v-text-field>
        <v-tooltip bottom>
          <v-btn :disabled="!sayfayetki.Save" slot="activator" @click="dizaynekle()" flat> <span
              class="hidden-sm-and-down"> <span class="hidden-sm-and-down">{{ $t('Add-Design') }}</span>
            </span>
            <v-icon right dark>add_box</v-icon>
          </v-btn>
          <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
          <span v-if="sayfayetki.Save">{{ $t('Add-Design') }}</span>
        </v-tooltip>


      </v-toolbar>
    </v-layout>

    <v-card>
      <v-card-title>
        <v-spacer></v-spacer>

      </v-card-title>
      <v-data-table :headers="headers" :rows-per-page-items=[50,100] :loading="progress" :items="dizaynitems"
        :search="search3">
        <v-progress-linear slot="progress" indeterminate></v-progress-linear>

        <template slot="items" slot-scope="props">
          <tr item>
            <td class="text-xs-left">{{ props.item.FaturaId }}</td>
            <td class="text-xs-left">{{ props.item.FaturaTabloAdi }}</td>
            <td class="text-xs-left">{{ props.item.FaturaAciklama }}</td>
            <td class="text-xs-left">{{ props.item.FaturaTip }}</td>
            <td class="text-xs-left">{{ props.item.FaturaTLDoviz }}</td>
            <td class="justify-center layout px-0">
              <v-btn icon small @click="Getir(props.item)">
                <v-icon small color="info">edit</v-icon>
              </v-btn>
              <v-btn icon small @click="dizaynAyarlar(props.item)">
                <v-icon small color="info">settings</v-icon>
              </v-btn>

            </td>

          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          {{ $t('No-records-searched-for', { value: search3}) }}
        </v-alert>
      </v-data-table>
    </v-card>

    <template>
      <v-card>
        <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
          :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
          {{ text1 }}
          <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
        </v-snackbar>
      </v-card>

      <v-dialog v-model="dialog1" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">{{ $t('Warning') }} !</v-card-title>
          <v-card-text>{{dialogmessage1}}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="info" flat @click.native="dialog1=false">{{$t("cancel_button")}}</v-btn>

            <v-btn color="info" flat @click="dizaynsil()">{{ $t('OK') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </template>
  </div>
</template>


<script>
  import auth from '../../../api/auth'
  import reportbrosablon from "@/components/app/coper/comp/reportbrosablon.vue";
  import helpers from "@/components/app/customcomp/helpers.js"
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"


  export default {
    data() {
      return {
        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0,
        },
        pdfclass: null,
        dizayn: null,
        dizaynitems: [],
        xsltitems: [],
        ListInput: {
          FaturaId: null,
          SirketKodu: null,
          FaturaTip: null,
          FaturaTLDoviz: 'T',
          FaturaTabloAdi: null,
          FaturaAciklama: null,
          FaturaMailDosya: null,
          FaturaPdfDosya: null,
          FaturaIcDis: 'I',
          FaturaXsltDosya: null,
          FaturaXsltId: null,
          FaturaDetayOzet: null,
          FaturaPdfID: null,
        },


        tooltip: false,
        el: null,
        text1: null,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,

        yenikayit: false,
        valid: true,


        headers: [{
            text: this.$t('Invoice-ID'),
            value: 'FaturaId'
          },
          {
            text: 'Fatura Tablo Adı',
            value: 'FaturaTabloAdi'
          },
          {
            text: this.$t('Description'),
            value: 'FaturaAciklama'
          },
          {
            text: this.$t('Invoice-Type'),
            value: 'FaturaTip'
          },
          {
            text: 'TL/' + this.$t('Currency'),
            value: 'FaturaTLDoviz'
          },
          {
            text: '',
            value: ''
          }
        ],
        loading: false,
        color: 'orange darken-4',
        yedeksirket: [],
        items: [],
        search3: '',
        search: null,
        select: [],
        selected: '',
        m: false,
        k: false,
        dialog: false,
        dialog1: false,
        dialogmessage1: '',

        state: [],

        dialog_baslik: '',

        bankakod: '',
        bankaadi: '',
        progress: false,
        dictionary: {
          custom: {
            sirketkod: {
              required: () => this.$t('This-space-cannot-left-blank'),
            },
            sirketadi: {
              required: () => this.$t('This-space-cannot-left-blank'),
            }
          }
        }
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },
    watch: {
      search(val) {
        val && this.carigetir(val)
      }
    },
    mounted() {
      this.$validator.localize('en', this.dictionary)

      this.sayfayetki = helpers.pageScreenAuth(this.$route.name)
      if (this.sayfayetki.Status == true) {



      } else {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {

            if (this.prevRoute != null) {
              let url = '#' + this.prevRoute

              window.open(url, '_self')
            } else {
              let url = '#/'
              window.open(url, '_self')
            }
          }

        });

      }
    },
    methods: {
      dizaynAyarlar(val) {
        var tip = null
        if (val.FaturaTip == 'O') {
          tip = 'B'
        } else {
          tip = 'S'
        }

        var url = '#/fatura/faturadizaynduzenle/id?' + 'faturaadi=' + val.FaturaTabloAdi + '&faturatip=' + tip +
          '&id=' + val.FaturaId
        window.open(url, '_target')

      },

      silsor() {
        this.dialogmessage1 = this.$t('Are-you-sure-you-want-delete-invoice-design');
        this.dialog1 = true;
      },

      Getir(v) {

        this.yenikayit = false,
          this.k = false
        this.m = true
        this.ListInput.FaturaId = v.FaturaId
        this.ListInput.FaturaTip = v.FaturaTip
        this.ListInput.FaturaTLDoviz = v.FaturaTLDoviz
        this.ListInput.FaturaTabloAdi = v.FaturaTabloAdi
        this.ListInput.FaturaAciklama = v.FaturaAciklama
        this.ListInput.FaturaMailDosya = v.FaturaMailDosya
        this.ListInput.FaturaPdfDosya = v.FaturaPdfDosya
        this.ListInput.FaturaIcDis = v.FaturaIcDis
        this.ListInput.FaturaXsltDosya = v.FaturaXsltDosya
        this.ListInput.FaturaXsltId = v.FaturaXsltId
        this.ListInput.FaturaDetayOzet = v.FaturaDetayOzet
        this.ListInput.FaturaPdfID = v.FaturaPdfID
        // this.pdfclass.id=10
        this.dialog = true
        this.dialog_baslik = 'Fatura Dizayn Güncelle'

      },
      dizaynsil: dizaynsil,
      dizaynekle: dizaynekle,
      Kaydet: Kaydet,
      guncelle: guncelle,
      vazgec: vazgec
    },
    beforeMount: beforeMount,

    components: {
      reportbrosablon,
      yetkidialog
    },
    vazgec: vazgec
  }

  function vazgec() {
    this.dialog = false
  }


  function Kaydet() {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));


    if (this.$refs.formdizayn.validate()) {

      if (this.ListInput.FaturaPdfID != 0 && this.ListInput.FaturaPdfID != null && this.ListInput.FaturaPdfID != '') {

        this.ListInput.SirketKodu = credentials.SirketKodu

        if (this.ListInput.FaturaIcDis == 'I' || this.ListInput.FaturaIcDis == 'D') {
          this.ListInput.FaturaTip = 'O'
        } else if (this.ListInput.FaturaIcDis == 'S') {
          this.ListInput.FaturaTip = 'S'

        }

        var params = this.ListInput
        this.$http.post(auth.API_URL + 'api/TicketInvoice/InvoiceMainTableSave', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          if (response.body.Status) {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
            this.dialog = false;
            this.dosyaokefatura = false
            this.dosyaokearsiv = false

            var params3 = {
              SirketKodu: credentials.SirketKodu,
              FaturaTip: null,
              DovizliFatura: false,
              HatTipi: false,
              TumFiltre: false
            }
            this.$http.post(auth.API_URL + 'api/TicketInvoice/InvoiceMainTableList', params3, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {
              this.dizaynitems = response.body
            }, (response) => {
              if (response.status === 0) {
                this.progress = false
                this.text1 = 'Service Unavailable-InvoiceMainTableList'
                this.snackbar = true
              } else {
                this.text1 = 'Service Unavailable-InvoiceMainTableList'
                this.snackbar = true
              }
            })


          } else {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
          }
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = response.statusText
            this.snackbar = true
          }
        })
      } else {
        this.text1 = this.$t('Select-PDF-template')
        this.snackbar = true
      }



    }
    //ListInput.FaturaPdfID
  }

  function dizaynekle() {


    this.ListInput.FaturaId = null,
      this.ListInput.FaturaTip = null,
      this.ListInput.FaturaTLDoviz = 'T',
      this.ListInput.FaturaTabloAdi = null,
      this.ListInput.FaturaAciklama = null,
      this.ListInput.FaturaMailDosya = null,
      this.ListInput.FaturaPdfDosya = null,
      this.ListInput.FaturaIcDis = 'I',
      this.ListInput.FaturaXsltDosya = null,
      this.ListInput.FaturaXsltId = null,
      this.ListInput.FaturaDetayOzet = null,
      this.ListInput.FaturaPdfID = null,


      this.dialog = true
    this.dialog_baslik = 'Dizayn Ekle';
    this.k = true;
    this.m = false;
  }

  function beforeMount() {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    var params3 = {
      SirketKodu: credentials.SirketKodu,
      FaturaTip: null,
      DovizliFatura: false,
      HatTipi: false,
      TumFiltre: false
    }
    this.$http.post(auth.API_URL + 'api/TicketInvoice/InvoiceMainTableList', params3, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.dizaynitems = response.body
    }, (response) => {
      if (response.status === 0) {
        this.progress = false
        this.text1 = 'Service Unavailable-InvoiceXsltTableList'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-InvoiceXsltTableList'
        this.snackbar = true
      }
    })

    var paramsxslt = {
      CompanyCode: credentials.SirketKodu
    }
    this.$http.post(auth.API_URL + 'api/TicketInvoice/InvoiceXsltTableList', paramsxslt, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.xsltitems = response.body
    }, (response) => {
      if (response.status === 0) {
        this.progress = false
        this.text1 = 'Service Unavailable-InvoiceXsltTableList'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-InvoiceXsltTableList'
        this.snackbar = true
      }
    })
  }

  function dizaynsil() {
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params3 = {
      CompanyCode: credentials.SirketKodu,
      InvoiceID: this.ListInput.FaturaId
    }

    this.$http.post(auth.API_URL + 'api/TicketInvoice/InvoiceMainTableDelete', params3, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {

      if (response.body.Status) {
        this.text1 = response.body.ResponseMessage
        this.snackbar = true
        this.dialog1 = false;
        this.dialog = false;
        var params3 = {
          SirketKodu: credentials.SirketKodu,
          FaturaTip: null,
          DovizliFatura: false,
          HatTipi: false,
          TumFiltre: false
        }
        this.$http.post(auth.API_URL + 'api/TicketInvoice/InvoiceMainTableList', params3, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.dizaynitems = response.body
        }, (response) => {
          if (response.status === 0) {
            this.progress = false
            this.text1 = 'Service Unavailable-InvoiceXsltTableList'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-InvoiceXsltTableList'
            this.snackbar = true
          }
        })
      }

    }, (response) => {
      if (response.status === 0) {
        this.progress = false
        this.text1 = 'Service Unavailable-InvoiceXsltTableList'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-InvoiceXsltTableList'
        this.snackbar = true
      }
    })
  }

  function guncelle() {

    if (this.file.length > 0) {
      var cred = JSON.parse(window.localStorage.getItem('credentials'));
      let formData = new FormData();
      for (var i = 0; i < this.file.length; i++) {
        let file = this.file[i];
        formData.append('file[' + i + ']', file);
      }
      formData.append('CustomerCode', cred.AnaSirketKodu)
      formData.append('TransferType', '0')
      axios.defaults.baseURL = auth.API_URL;
      axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';
      axios.post(auth.API_URL + 'api/TicketDefinitons/FileUploadxslt',
          formData, {
            headers: {
              Authorization: `Bearer ${auth.getAuthHeader()}`
            }
          }
        ).then((response) => {

          if (response.data == true) {

            this.load2 = true
            this.load = false
            this.text1 = this.$t('Xslt-Transfers-have-been-completed')
            this.snackbar = true
          } else {
            this.text1 = this.$t('Your-Xslt-files-could-transferred-Please-try-again')
            this.snackbar = true
          }
        })
        .catch(function () {});
    }

    if (this.file2.length > 0) {

      var cred = JSON.parse(window.localStorage.getItem('credentials'));
      let formData = new FormData();
      for (var i = 0; i < this.file2.length; i++) {
        let file = this.file2[i];
        formData.append('file[' + i + ']', file);
      }
      formData.append('CustomerCode', cred.AnaSirketKodu)
      formData.append('TransferType', '1')
      axios.defaults.baseURL = auth.API_URL;
      axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';
      axios.post(auth.API_URL + 'api/TicketDefinitons/FileUploadxslt',
          formData, {
            headers: {
              Authorization: `Bearer ${auth.getAuthHeader()}`
            }
          }
        ).then((response) => {
          if (response.data == true) {
            this.ListInput.XsltAd1 = this.dosyayolu2;

            this.load2 = true
            this.load = false
            this.text1 = this.$t('Xslt-Transfers-have-been-completed')
            this.snackbar = true
          } else {
            this.text1 = "Xslt dosyalarınız aktarılamadı. Tekrar deneniyiniz."
            this.snackbar = true
          }
        })
        .catch(function () {

        });
    }

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    this.ListInput.SirketKodu = credentials.SirketKodu


    if (this.dosyaokearsiv == true) {
      this.ListInput.XsltAd = this.dosyayolu1;
    }

    if (this.dosyaokefatura == true) {
      this.ListInput.XsltAd1 = this.dosyayolu2;
    }

    var params = this.ListInput

    this.$http.post(auth.API_URL + 'api/TicketInvoice/InvoiceXsltTableSave', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      if (response.body.Status) {

        this.text1 = response.body.ResponseMessage
        this.snackbar = true;
        this.dialog = false;
        this.dosyaokefatura = false;
        this.dosyaokearsiv = false;

        var params3 = {
          CompanyCode: credentials.SirketKodu
        }

        this.$http.post(auth.API_URL + 'api/TicketInvoice/InvoiceXsltTableList', params3, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.xsltitems = response.body
        }, (response) => {
          if (response.status === 0) {
            this.progress = false
            this.text1 = 'Service Unavailable-InvoiceXsltTableList'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-InvoiceXsltTableList'
            this.snackbar = true
          }
        })
      } else {
        this.text1 = response.body.ResponseMessage
        this.snackbar = true
      }
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = response.statusText
        this.snackbar = true
      }
    })


  }
</script>

<style>
</style>